/**
 * @module editablefield/editablefield
 */

import { Plugin } from 'ckeditor5/src/core';
import EditableFieldEditing from './editablefieldediting';
import EditableFieldUI from './editablefieldui';
import '../theme/editablefield.pcss';

/**
 * The EditableField plugin.
 *
 * It loads the {@link module:editablefield/editablefieldediting~EditableFieldEditing EditableFieldEditing feature}
 * and the {@link module:editablefield/editablefieldui~EditableFieldUI EditableFieldUI feature}
 *
 * @extends {Plugin}
 */
export default class EditableField extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'EditableField';
	}

	/**
	 * @inheritDoc
	 */
	static get requires() {
		return [ EditableFieldEditing, EditableFieldUI ];
	}
}
